import { render, staticRenderFns } from "./custom-contact-field.vue?vue&type=template&id=af7da33c&scoped=true&"
import script from "./custom-contact-field.vue?vue&type=script&lang=ts&"
export * from "./custom-contact-field.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7da33c",
  null
  
)

export default component.exports